import {
  BaseballEventStatusId,
  BaseballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { ManualAddIncidentConfig } from '../../configuration'

export const manualAddIncidentConfig: ManualAddIncidentConfig<
  BaseballIncidentId,
  BaseballEventStatusId
> = {
  getKeyIncidents: () => [
    BaseballIncidentId.Run,
    BaseballIncidentId.HomeRun,
    BaseballIncidentId.Hit,
    BaseballIncidentId.Strikeout,
    BaseballIncidentId.Error,
    BaseballIncidentId.PlateAppearance,
  ],
  otherIncidents: [
    BaseballIncidentId.Out,
    BaseballIncidentId.StolenBase,
    BaseballIncidentId.CaughtStealing,
    BaseballIncidentId.Walk,
    BaseballIncidentId.HitByPitch,
    BaseballIncidentId.PickOffAttempt,
    BaseballIncidentId.DoublePlay,
    BaseballIncidentId.TriplePlay,
    BaseballIncidentId.WildPitch,
    BaseballIncidentId.Ball,
    BaseballIncidentId.Strike,
    BaseballIncidentId.SwingAndMiss,
    BaseballIncidentId.Foul,
  ],
  eventStatuses: [
    BaseballEventStatusId.FirstInning,
    BaseballEventStatusId.SecondInning,
    BaseballEventStatusId.ThirdInning,
    BaseballEventStatusId.FourthInning,
    BaseballEventStatusId.FifthInning,
    BaseballEventStatusId.SixthInning,
    BaseballEventStatusId.SeventhInning,
    BaseballEventStatusId.EighthInning,
    BaseballEventStatusId.NinthInning,
    BaseballEventStatusId.TenthInning,
    BaseballEventStatusId.EleventhInning,
    BaseballEventStatusId.TwelfthInning,
  ],
}
